import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import cs from "classnames";

import { Icon } from "../../shared/Icon/Icon";

import "./ModalSidebar.scss";

interface ModalSidebarProps {
  isOpen: boolean;
  title: string;
  loading?: boolean;
  isDisabled?: boolean;
  children: React.ReactNode;
  className?: string;
  submitButtonLabel?: string;
  headerDescription?: React.ReactNode;
  footerDescription?: string;
  footerDescriptionClassName?: string;
  centered?: boolean;
  onToggle: () => void;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export default function ModalSidebar(props: ModalSidebarProps) {
  const handleSubmit = () => {
    if (props.onSubmit) {
      props.onSubmit();
    }
  };

  const handleCancel = () => {
    props.onToggle();
  };

  const classes = cs("ModalSidebar", props.className, {
    "ModalSidebar--middle": props.centered,
  });

  return (
    <Modal isOpen={props.isOpen} toggle={props.onToggle} className={classes}>
      <div className="modal-header">
        <div className="modal-header-content">
          <div className="modal-header-top">
            <h5 className="modal-title">{props.title}</h5>

            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={props.onToggle}
            >
              <Icon icon="close-icon" />
            </button>
          </div>

          {props.headerDescription && (
            <div className="modal-header-description">
              {props.headerDescription}
            </div>
          )}
        </div>
      </div>
      <ModalBody>{props.children}</ModalBody>
      {props.onSubmit && (
        <ModalFooter>
          {props.footerDescription && (
            <span
              className={cs(
                "ModalSidebar__footerDescription",
                props.footerDescriptionClassName
              )}
            >
              {props.footerDescription}
            </span>
          )}

          <Button color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="px-4 py-2"
            onClick={handleSubmit}
            disabled={props.isDisabled || props.loading}
          >
            {props.loading
              ? "Processing..."
              : props.submitButtonLabel || "Save"}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}
